import { useTranslation } from 'react-i18next';
import { Outlet } from '@tanstack/react-router';
import { dashboardContext } from '@features/auth/model/session';
import { canOpenDashboard, type Dashboard } from '@shared/lib/roles';
import { useSession } from '@shared/session/store';
import { AccessDenied } from '@shared/ui';

/** Renders the dashboard subtree only for users holding a matching role; otherwise a 403 state. */
export function DashboardGate({ dashboard }: { dashboard: Dashboard }) {
  const { t } = useTranslation('common');
  const session = useSession();
  if (!canOpenDashboard(dashboard, dashboardContext(session))) {
    return <AccessDenied reason={t(`errors.forbidden.${dashboard}` as 'errors.forbidden.admin')} />;
  }
  return <Outlet />;
}
